import { render, staticRenderFns } from "./FaceRecoEventDetails.vue?vue&type=template&id=09589f38&scoped=true"
import script from "./FaceRecoEventDetails.vue?vue&type=script&lang=js"
export * from "./FaceRecoEventDetails.vue?vue&type=script&lang=js"
import style0 from "./FaceRecoEventDetails.vue?vue&type=style&index=0&id=09589f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09589f38",
  null
  
)

/* custom blocks */
import block0 from "./FaceRecoEventDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports